import { FieldErrors } from "react-hook-form";
import { IApplyOnline } from "@/src/types/applyOnline";
import {
  FORM_OF_EDUCATION_DISTANCE,
  FORM_OF_EDUCATION_FULL_TIME,
} from "@/src/constants/AdmissionOffice/Malta/maltaFormOfEducationOptions";

/** User-editable fields required before submit. form_type is set on submit; form_office maps from office. */
export const APPLY_ONLINE_REQUIRED_FIELD_KEYS = ["fullname", "email", "phone", "office"] as const;

export type ApplyOnlineRequiredFieldKey = (typeof APPLY_ONLINE_REQUIRED_FIELD_KEYS)[number];

export const APPLY_ONLINE_FIELD_RULES = {
  fullname: { required: "Name is required" },
  office: { required: "Office is required" },
  phone: { required: "Phone is required" },
  email: {
    required: "Email is required",
    pattern: {
      value: /^\S+@\S+$/i,
      message: "Invalid email address",
    },
  },
} as const;

const isFieldFilled = (value: unknown): boolean => value != null && String(value).trim() !== "";

export const isApplyOnlineFormReady = (data: IApplyOnline | undefined, errors: FieldErrors<IApplyOnline>): boolean => {
  const hasRequiredValues = APPLY_ONLINE_REQUIRED_FIELD_KEYS.every((key) => isFieldFilled(data?.[key]));
  const hasRequiredErrors = APPLY_ONLINE_REQUIRED_FIELD_KEYS.some((key) => Boolean(errors[key]));
  return hasRequiredValues && !hasRequiredErrors;
};

export const APPLY_ONLINE_DEFAULT_VALUES: IApplyOnline = {
  office: "",
  passportNumber: "",
  fullname: "",
  phone: "",
  email: "",
  birthDate: "",
  nationality: "",
  country: "",
  address: "",
  speciality: "",
  levelEducation: "",
  formStudy: "",
  comment: "",
  filePassport: [],
  fileCertificate: [],
  fileEducation: [],
  fileAnouther: [],
};

export const ApplyFormSummaryConst = [
  {
    id: "fast",
    title: "Quick Application",
    fields: [
      { name: "Full Name", value: "Full Name", className: "fullname" },
      { name: "Office", value: "Office", className: "office" },
      { name: "Phone Number", value: "Phone Number", className: "phone" },
      { name: "Email", value: "Email", className: "email" },
    ],
  },
  {
    id: "dop-info",
    title: "Additional Information",
    fields: [
      { name: "Date of Birth", value: "Date of Birth", className: "birthDate" },
      { name: "Nationality", value: "Nationality", className: "nationality" },
      { name: "Address", value: "Address", className: "address" },
      { name: "Previous Education", value: "Previous Education", className: "education" },
    ],
  },
  {
    id: "program-details",
    title: "Program Details",
    fields: [
      { name: "Degree Level", value: "Degree Level", className: "levelEducation" },
      { name: "Speciality", value: "Speciality", className: "speciality" },
      { name: "Study Mode", value: "Study Mode", className: "formStudy" },
      { name: "Comment", value: "Comment", className: "comment" },
    ],
  },
];

export const ApplyOnlineOptionsConst = {
  office: [
    { value: "", label: "-- Select office --", disabled: true },
    { value: "UKRAINE", label: "Ukraine" },
    { value: "MALTA", label: "Malta" },
    { value: "POLAND", label: "Poland" },
  ],
  nationality: [
    { value: "", label: "-- Select nationality --", disabled: true },
    { value: "Ukraine", label: "Ukraine" },
    { value: "Poland", label: "Poland" },
    { value: "Germany", label: "Germany" },
    { value: "USA", label: "USA" },
    { value: "France", label: "France" },
    { value: "Italy", label: "Italy" },
    { value: "Spain", label: "Spain" },
  ],
  country: [
    { value: "", label: "-- Select country --", disabled: true },
    { value: "Ukraine", label: "Ukraine" },
    { value: "Poland", label: "Poland" },
    { value: "Germany", label: "Germany" },
    { value: "USA", label: "USA" },
    { value: "France", label: "France" },
    { value: "Italy", label: "Italy" },
    { value: "Spain", label: "Spain" },
  ],
  speciality: [
    { value: "", label: "-- Select --", disabled: true },
    { value: "sec1", label: "sec1" },
    { value: "sec2", label: "sec2" },
    { value: "sec3", label: "sec3" },
  ],
  levelEducation: [
    { value: "", label: "Degree Level", disabled: true },
    { value: "Bachelor's Degree", label: "Bachelor's Degree" },
    { value: "Master's Degree", label: "Master's Degree" },
    { value: "Ph.D/Doctorate", label: "Ph.D/Doctorate" },
  ],
  formStudy: [
    { value: "", label: "Mode of Study", disabled: true },
    { value: FORM_OF_EDUCATION_FULL_TIME, label: FORM_OF_EDUCATION_FULL_TIME },
    { value: FORM_OF_EDUCATION_DISTANCE, label: FORM_OF_EDUCATION_DISTANCE },
  ],
};
